export default __webpack_public_path__ + "static/media/240c57a0-fdce-440d-9ce3-85e0cb56f470.4c7f5997.woff2";